import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    detectSessionInUrl: true,
    // Automatically refreshes JWT token to include organization_id
    autoRefreshToken: true,
  },
});

// Helper to extract organization_id from the JWT token
export const getOrganizationId = async () => {
  try {
    const { data } = await supabase.auth.getClaims();
    return data.claims?.app_metadata?.organization_id || null;
  } catch (error) {
    console.error("Error fetching organization ID:", error);
    return null;
  }
};

// Function to switch the active organization
export const switchOrganization = async (organizationId: string) => {
  try {
    // Call the auth.switch_organization function to update active org
    const { data, error } = await supabase.rpc("switch_organization", {
      new_organization_id: organizationId,
    });

    if (error) throw error;

    // Force JWT refresh to get the new organization info
    await supabase.auth.refreshSession();

    return { success: true };
  } catch (error) {
    console.error("Error switching organization:", error);
    return { success: false, error };
  }
};
